import React, { useEffect, useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ServicesContext from "../../../contexts/servicesContext";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  Toolbar,
  Typography,
  Grid,
  Paper,
  Box,
  Popover,
  IconButton,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Checkbox,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import TablePaginationActions from "../../utils/TablePaginationActions";
import { Skeleton } from "@material-ui/lab";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    flexDirection: "row",
  },
  title: {
    flex: "1 1 100%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  headerDiv: {
    display: "flex",
    flexDirection: "row",
  },
  createBtn: {
    textAlign: "right",
  },
  button: {
    margin: theme.spacing(1),
  },
  dialogModal: {
    width: "500px",
  },
}));

function AetRegionList() {
  const rowsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [regions, setRegions] = useState([]);
  const [regionId, setRegionId] = useState();
  const [checked, setChecked] = useState(true);
  const [editRegion, setEditRegion] = useState();
  const [regionsCount, setRegionsCount] = useState(0);
  const [refreshPage, setRefreshPage] = useState(false);

  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClickOpenDialog = () => {
    setOpenDialog(true);
    setChecked(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setRegionId();
    setEditRegion();
  };
  const handleSubmitDialog = () => {
    if (regionId !== null && regionId !== undefined) {
      services.aet
        .updateRegion(regionId, editRegion.name, editRegion.isUsed)
        .then(() => {
          setOpenDialog(false);
          setRegionId();
          setEditRegion();
          setShowSuccessEditNotif(true);
          setOpenEditNotif(true);
          setRefreshPage(!refreshPage);
        })
        .catch(() => {
          setShowErrorEditNotif(true);
          setOpenEditNotif(true);
          setRefreshPage(!refreshPage);
        });
    } else {
      services.aet
        .createRegion(editRegion.name, editRegion.isUsed !== undefined ? editRegion.isUsed : true)
        .then(() => {
          setOpenDialog(false);
          setRegionId();
          setEditRegion();
          setShowSuccessEditNotif(true);
          setOpenEditNotif(true);
          setRefreshPage(!refreshPage);
        })
        .catch(() => {
          setShowErrorEditNotif(true);
          setOpenEditNotif(true);
          setRefreshPage(!refreshPage);
        });
    }
  };
  const handleEditRegion = (regionId) => {
    setRegionId(regionId);
    handleClickOpenDialog();
  };

  useEffect(() => {
    if (regionId !== null && regionId !== undefined) {
      services.aet.getRegionById(regionId).then((response) => {
        setEditRegion(response.data);
        setChecked(response.data.isUsed)
      });
    }
  }, [regionId]);

  const [open, setOpen] = useState(true);
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const [openEditNotif, setOpenEditNotif] = useState(true);
  const [showErrorEditNotif, setShowErrorEditNotif] = useState(false);
  const [showSuccessEditNotif, setShowSuccessEditNotif] = useState(false);

  function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setShowError(false);
    setShowSuccess(false);
    setOpenEditNotif(false);
    setShowErrorEditNotif(false);
    setShowSuccessEditNotif(false);
  }

  const classes = useStyles();
  const services = useContext(ServicesContext);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleDeleteRegion = (regionId) => {
    if (regionId !== null && regionId !== undefined) {
      services.aet
        .deleteRegion(regionId)
        .then(() => {
          setShowSuccess(true);
          setOpen(true);
          setRefreshPage(!refreshPage);
        })
        .catch(() => {
          setShowErrorEditNotif(true);
          setOpen(true);
          setRefreshPage(!refreshPage);
        });
    }
  };

  useEffect(() => {
    setLoading(true);
    services.aet.getAllRegions().then((response) => {
      setRegions(response.data);
      setLoading(false);
    });
  }, [currentPage, services, refreshPage]);

  return (
    <Paper className={classes.paper}>
      <Toolbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={classes.headerDiv}>
              <Typography
                className={classes.title}
                variant="h6"
                id="tableTitle"
                component="div"
              >
                Регионы
              </Typography>
              <Grid item xs={12} className={classes.createBtn}>
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={handleClickOpenDialog}
                >
                  Добавить регион
                </Button>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Toolbar>
      <Table aria-label="custom pagination table">
        <TableHead>
          <TableRow>
            <TableCell>№</TableCell>
            <TableCell>Названия</TableCell>
            <TableCell>Используется</TableCell>
            <TableCell align="right">Действие</TableCell>
          </TableRow>
        </TableHead>

        {loading ? (
          <TableBody>
            {[...Array(10)].map((x, i) => {
              return (
                <TableRow key={i}>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row" align="right">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row" align="right">
                    <Skeleton variant="text" />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        ) : (
          <TableBody>
            {regions?.map((region) => (
              <TableRow key={region?.id}>
                <TableCell component="th" scope="row">
                  {region?.id}
                </TableCell>
                <TableCell component="th" scope="row">
                  {region?.name}
                </TableCell>
                <TableCell component="th" scope="row">
                  {region?.isUsed ? "Да" : "Нет"}
                </TableCell>
                <TableCell component="th" scope="row" align="right">
                  <IconButton
                    aria-label="edit"
                    size="small"
                    className={classes.button}
                    onClick={() => handleEditRegion(region?.id)}
                  >
                    <EditIcon />
                  </IconButton>
                  <PopupState variant="popover" popupId="demo-popup-popover">
                    {(popupState) => (
                      <>
                        <IconButton
                          aria-label="delete"
                          size="small"
                          className={classes.button}
                          {...bindTrigger(popupState)}
                        >
                          <DeleteIcon />
                        </IconButton>
                        <Popover
                          {...bindPopover(popupState)}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                        >
                          <Box p={2}>
                            <Typography>
                              Вы уверены, что хотите удалить?
                            </Typography>
                            <Button
                              variant="outlined"
                              className={classes.button}
                              size="small"
                              onClick={() => {
                                popupState.close();
                                handleDeleteRegion(region?.id);
                              }}
                            >
                              да
                            </Button>
                            <Button
                              variant="outlined"
                              className={classes.button}
                              size="small"
                              onClick={popupState.close}
                            >
                              нет
                            </Button>
                          </Box>
                        </Popover>
                      </>
                    )}
                  </PopupState>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
      <TablePagination
        count={regionsCount}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        component="div"
        rowsPerPageOptions={[]}
        onChangePage={handleChangePage}
        ActionsComponent={TablePaginationActions}
      />
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {regionId ? "Редактирование" : "Добавление региона(город)"}
        </DialogTitle>
        <DialogContent className={classes.dialogModal}>
          {editRegion ? (
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Введите название"
              type="text"
              fullWidth
              value={editRegion.name}
              onChange={(e) => {
                const updatedName = e.target.value;
                setEditRegion((prevRegion) => ({
                  ...prevRegion,
                  name: updatedName,
                }));
              }}
            />
          ) : (
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Введите название"
              type="text"
              fullWidth
              onChange={(e) => {
                const updatedName = e.target.value;
                setEditRegion((prevRegion) => ({
                  ...prevRegion,
                  name: updatedName,
                }));
              }}
            />
          )}
        </DialogContent>
        <DialogContent className={classes.dialogModal}>
          {editRegion ? (
            <p> Используется
              <Checkbox
                id="isUsed"
                checked={checked}
                label="Используется"
                onChange={() => {
                  setChecked(!checked);
                  setEditRegion((prevRegion) => ({
                    ...prevRegion,
                    isUsed: !checked,
                  }));
                }}
                color="primary"
              />
            </p>
          ) : (
            <p> Используется
              <Checkbox
                id="isUsed"
                checked={checked}
                label="Используется"
                onChange={() => {
                  setChecked(!checked);
                  setEditRegion((prevRegion) => ({
                    ...prevRegion,
                    isUsed: checked,
                  }));
                }}
                color="primary"
              />
            </p>
            // <TextField
            //   autoFocus
            //   margin="dense"
            //   id="isUsed"
            //   label="Используется"
            //   type="bool"
            //   fullWidth
            //   onChange={(e) => {
            //     const updatedIsUsed = e.target.value;
            //     setEditRegion((prevRegion) => ({
            //       ...prevRegion,
            //       name: updatedIsUsed,
            //     }));
            //   }}
            // />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmitDialog} color="primary">
            {regionId ? "Изменить" : "Сохранить"}
          </Button>
          <Button onClick={handleCloseDialog} color="primary">
            Отмена
          </Button>
        </DialogActions>
      </Dialog>
      {showError && (
        <div>
          <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
          >
            <Alert
              onClose={handleClose}
              severity="warning"
              variant="filled"
              elevation={6}
              sx={{ width: "100%" }}
            >
              Не удалось удалить!
            </Alert>
          </Snackbar>
        </div>
      )}
      {showSuccess && (
        <div>
          <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
          >
            <Alert
              onClose={handleClose}
              severity="success"
              variant="filled"
              elevation={6}
              sx={{ width: "100%" }}
            >
              Успешно удален!
            </Alert>
          </Snackbar>
        </div>
      )}
      {showErrorEditNotif && (
        <div>
          <Snackbar
            open={openEditNotif}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
          >
            <Alert
              onClose={handleClose}
              severity="warning"
              variant="filled"
              elevation={6}
              sx={{ width: "100%" }}
            >
              Не удалось сохранить данные!
            </Alert>
          </Snackbar>
        </div>
      )}
      {showSuccessEditNotif && (
        <div>
          <Snackbar
            open={openEditNotif}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
          >
            <Alert
              onClose={handleClose}
              severity="success"
              variant="filled"
              elevation={6}
              sx={{ width: "100%" }}
            >
              Данные успешно сохранены!
            </Alert>
          </Snackbar>
        </div>
      )}
    </Paper>
  );
}
export default AetRegionList;
